import { render, staticRenderFns } from "./BUDropdown.vue?vue&type=template&id=2aceca24"
import script from "./BUDropdown.vue?vue&type=script&lang=js"
export * from "./BUDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports